import * as decode from 'jwt-decode';
import { DateAdapter } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'app/services/general.service';
import { Router } from '@angular/router';
import { TranslateService } from 'ng2-translate';
import { Component, OnInit, Inject } from '@angular/core';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import {DatePipe} from '@angular/common';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-comunicados-show',
  templateUrl: './comunicados-show.html',
  styleUrls: ['./comunicados-show.scss']
})
export class ModalComunicadosShowComponent implements OnInit {

  userToken;
  userId;
  isExternal;
  perfilId;
  providerActive;
  //data: any = {};
  pdfSrc = null;
  base64pdf = null;
  id : string;
  comunicado : any ={
    Titulo : ""
  }

  Notices=[];
  constructor(private toastr: ToastrService,
    public dialog: MatDialog,
    private gralService: GeneralService,
    private router: Router,
    private translate: TranslateService,
    private adapter: DateAdapter<any>,
    public dialogRef: MatDialogRef<ModalComunicadosShowComponent>, @Inject(MAT_DIALOG_DATA) public dataInfo: any
  ){

    this.id =this.dataInfo.id ;
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');

    const tokenPayload = decode(d[1]);

    this.userId = tokenPayload.Id;
    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;

    gralService.changeTextHead('NOTICE');

  }

  ngOnInit() {
    this.detailDoc( this.id );
  }



  detailDoc(id){
    this.gralService.getSingleNote(id, 'token').then((res:any) => {

      this.comunicado =res.Entidad;
      this.base64pdf = res.Entidad.ComunicadoPDFBase64;
      //const sampleBytes = this.base64ToArrayBuffer(res.Entidad.ComunicadoPDFBase64);
      //this.pdfSrc = sampleBytes;
    });
  }

  base64ToArrayBuffer(base64) {
    const binaryString =  window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++)        {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

}
